import React from "react";

export default function Card({ jobOpening }) {
  return (
    <div className="flex flex-col border-darkGrey/50 border-b-[0.5px] md:justify-between gap-1 lg:mt-8 pb-5">
      <h1 className="text-darkGrey uppercase font-havletica font-light">
        {jobOpening?.title}
      </h1>

 
      <span className="text-sm text-darkGrey">
        {jobOpening?.location} | {jobOpening?.timing}
      </span>
    </div>
  );
}
